import { DISCLAIMER_VERSION } from "../constants/disclaimer";

const DISCLAIMER_ACCEPTANCE_STORAGE_KEY = "slam_disclaimer_acceptance";
const DISCLAIMER_BROWSER_ID_STORAGE_KEY = "slam_browser_id";

const generateBrowserId = () => {
  if (typeof window !== "undefined" && window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }

  return `bid_${Date.now()}_${Math.random().toString(16).slice(2, 10)}`;
};

const getOrCreateBrowserId = () => {
  try {
    const existingBrowserId = window.localStorage.getItem(DISCLAIMER_BROWSER_ID_STORAGE_KEY);
    if (existingBrowserId) {
      return existingBrowserId;
    }

    const newBrowserId = generateBrowserId();
    window.localStorage.setItem(DISCLAIMER_BROWSER_ID_STORAGE_KEY, newBrowserId);
    return newBrowserId;
  } catch {
    return generateBrowserId();
  }
};

const parseAcceptanceRecord = (rawValue) => {
  if (!rawValue) {
    return null;
  }

  try {
    const parsed = JSON.parse(rawValue);
    if (
      typeof parsed?.acceptedAt !== "string" ||
      typeof parsed?.disclaimerVersion !== "string" ||
      typeof parsed?.browserId !== "string"
    ) {
      return null;
    }

    return parsed;
  } catch {
    return null;
  }
};

const getDisclaimerAcceptanceRecord = () => {
  try {
    const rawValue = window.localStorage.getItem(DISCLAIMER_ACCEPTANCE_STORAGE_KEY);
    return parseAcceptanceRecord(rawValue);
  } catch {
    return null;
  }
};

const hasAcceptedCurrentDisclaimer = () => {
  const acceptanceRecord = getDisclaimerAcceptanceRecord();
  return acceptanceRecord?.disclaimerVersion === DISCLAIMER_VERSION;
};

const acceptDisclaimer = () => {
  const acceptanceRecord = {
    acceptedAt: new Date().toISOString(),
    disclaimerVersion: DISCLAIMER_VERSION,
    browserId: getOrCreateBrowserId(),
  };

  try {
    window.localStorage.setItem(DISCLAIMER_ACCEPTANCE_STORAGE_KEY, JSON.stringify(acceptanceRecord));
  } catch {
    // Continue even if storage is unavailable.
  }

  return acceptanceRecord;
};

export {
  DISCLAIMER_ACCEPTANCE_STORAGE_KEY,
  DISCLAIMER_BROWSER_ID_STORAGE_KEY,
  acceptDisclaimer,
  getDisclaimerAcceptanceRecord,
  hasAcceptedCurrentDisclaimer,
};
